module.exports = __webpack_public_path__ + "static/img/img_6.e9bf333.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_6.png
// module id = bZOP
// module chunks = 0